import React from 'react';
import { Outlet } from 'react-router-dom';

interface TagsRootPageInterface {}

const TagsRootPage: React.FC<TagsRootPageInterface> = () => <Outlet />;

export default TagsRootPage;
